<script setup lang="ts">
  import type { Organization } from '@/types/organization'
  import FormHeading from '@/components/form/FormHeading.vue'
  import SelectOrganization from '@/components/organization/SelectOrganization.vue'
  import OrganizationInfo from '@/components/idf-modal/OrganizationInfo.vue'
  import { type Nullish, UiButton } from '@logistiek-zonder-papier/lzp-library'
  import { useJourneyTemplateStore } from '@/store/journey-template.store'
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'

  const journeyTemplateStore = useJourneyTemplateStore()
  const { canRemoveIhm } = storeToRefs(journeyTemplateStore)
  const showButton = computed(() => !!ihmOrganization.value)

  defineProps<{
    headingLabel: string
    error?: string | undefined
  }>()

  const ihmOrganization = defineModel<Organization | Nullish>('ihmOrganization')
</script>

<template>
  <FormHeading :label="headingLabel" />
  <div class="select-container">
    <div class="select-organization">
      <SelectOrganization v-model="ihmOrganization" :error="error" />
    </div>
    <UiButton
      v-if="canRemoveIhm && showButton"
      @click="journeyTemplateStore.removeIhm()"
      variant="negative"
      icon="cross"
      size="small"
    />
  </div>
  <OrganizationInfo v-if="ihmOrganization" :organization="ihmOrganization" />
</template>

<style scoped>
  .select-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }

  .select-organization {
    flex-grow: 1;
  }
</style>
